import i18n from 'i18next';
import * as yup from 'yup';

const clientCreationFormSchema = yup.object().shape({
  name: yup
    .string()
    .trim()
    .required(() => i18n.t('common.message.requiredField')),
  description: yup.string(),
});

export default clientCreationFormSchema;
